export { default } from './Flows.container'



// WEBPACK FOOTER //
// ./src/pages/Flows/index.js